"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationContext = void 0;
const react_1 = require("react");
exports.NavigationContext = react_1.createContext(undefined);
//# sourceMappingURL=navigation-context.js.map